import script from "./IntegrationSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./IntegrationSettings.vue?vue&type=script&setup=true&lang=js"

import "./IntegrationSettings.vue?vue&type=style&index=0&id=66c71aa4&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\banjara_matrimonial\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66c71aa4"]])

export default __exports__